import React, { useState, useEffect, useRef } from 'react';
import { get, post, put } from '../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { EditIcon } from './icons';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from './Pagination';
import useDebounce from './useDebounce';
import Breadcrumb from '../components/Breadcrumb';
import { GetFinancialYearsArray, fetchBillAmountForReport } from '../util/helper';
import billDetail from './BillDetail';
import { GrDocumentExcel } from 'react-icons/gr';

const BillConsolidatedReport = () => {
  const formFields = {
    companyId: '',
    locationType: '',
    locationId: '',
    locationRefName: '',
    billType: '',
    accountId: '',
    locationOwnerName: '',
    dueDate: '',
    remarks: '',
  };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [billParametersData, setBillParametersData] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const clickToDownload = useRef(null);

  //   const clickToDownload = useRef(null);
  const [state, setState] = useState({
    billType: '',
    companyId: '',
    locationType: '',
    locationId: '',
    query: '',
    financialYear: new Date().getFullYear(),
  });

  function getBillParameter() {
    try {
      get(
        `/bill-parameters/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${state.query}&billType=${state.billType}&companyId=${state.companyId}&locationType=${state.locationType}&locationId=${state.locationId}&financialYear=${state.financialYear}`
      ).then((response) => {
        setBillParametersData(response.data.rows);
        setTotalRecords(response.data.count);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function downloadBillConsolidatedReport() {
    try {
      get(
        `/bill-parameters/?query=${state.query}&billType=${state.billType}&companyId=${state.companyId}&locationType=${state.locationType}&locationId=${state.locationId}&financialYear=${state.financialYear}&conditionType=download`
      ).then((response) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getCompanies() {
    try {
      get(`/companies`).then((response) => {
        setCompanyList(response.data.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || 'something went wrong');
    }
  }

  const getLocations = () => {
    try {
      get(`/branches`).then((response) => {
        setLocationList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getBillParameter();
      }
    },
    [state],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getCompanies();
    getLocations();
  }, []);

  useEffect(() => {
    getBillParameter();
  }, [currentPage]);

  const generateAmountColumns = (billDetails, year) => {
    const payments = fetchBillAmountForReport(billDetails, year);
    return [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3].map((num) => {
      return <td>{payments[`${num}-${num < 4 ? year + 1 : year}`]}</td>;
    });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Store Operations' },
          { link: '#', title: 'Bill Management' },
          { link: '#', title: 'Bill Consolidated' },
        ]}
      />
      <div className="card custom_card">
        <div className="d-flex justify-content-between card-header card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-12 col-lg-2">
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              Bill Consolidated | {totalRecords ?? 0}
            </h4>
            <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
          </div>
          <div className="col-12 col-lg-8 text-end">
            <div className="row align-items-center">
              <div className="col-3">
                <Form.Select
                  value={state.billType}
                  onChange={(e) => setState({ ...state, billType: e.target.value })}
                  placeholder="Bill Type"
                  className="input mb-2"
                >
                  <option value="">Select Bill Type</option>
                  <option value="Electricity">Electricity</option>
                  <option value="Water">Water</option>
                  <option value="Tele/Wi-Fi">Tele/Wi-Fi</option>
                </Form.Select>
                <Form.Select
                  value={state.financialYear}
                  onChange={(e) => setState({ ...state, financialYear: e.target.value })}
                  placeholder="Financial Year"
                  className="input"
                >
                  <option value="">Select Financial Year</option>
                  {GetFinancialYearsArray(2021).map((year) => (
                    <option key={year} value={year}>
                      {year}-{year + 1}
                    </option>
                  ))}
                </Form.Select>
              </div>
              <div className="col-4">
                <Form.Select
                  value={state.companyId}
                  onChange={(e) => {
                    setState({
                      ...state,
                      companyId: e.target.value,
                      locationType: '',
                      locationId: '',
                    });
                  }}
                  className="input mb-2"
                >
                  <option value="">Select Company</option>
                  {companyList.map((company) => {
                    return (
                      <option key={company?.id} value={company?.id}>
                        {company?.name}
                      </option>
                    );
                  })}
                </Form.Select>
                <Form.Control
                  value={state.query}
                  onChange={(e) => setState({ ...state, query: e.target.value })}
                  type="search"
                  placeholder="Search by account id, ref name"
                />
              </div>
              <div className="col-4">
                <Form.Select
                  value={state.locationType}
                  onChange={(e) => {
                    setState({ ...state, locationType: e.target.value, locationId: '' });
                  }}
                  className="input mb-2"
                >
                  <option value="">Select Location Type</option>
                  <option value="office">Office</option>
                  <option value="factory">Factory</option>
                  <option value="outlet">Outlet</option>
                  <option value="staff-room">Staff Room</option>
                </Form.Select>
                <Form.Select value={state.locationId} onChange={(e) => setState({ ...state, locationId: e.target.value })}>
                  <option value="">Select Location</option>
                  {locationList
                    .filter((item) => {
                      return item?.type === state.locationType && item?.companyId === parseInt(state?.companyId);
                    })
                    .map((item) => {
                      return (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                </Form.Select>
              </div>
              <div className="col-1">
                <GrDocumentExcel
                  title="Download grns report"
                  className="react-icons green"
                  style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                  onClick={downloadBillConsolidatedReport}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Company</th>
                    <th>Location Type</th>
                    <th>Location</th>
                    <th>Location Ref Name</th>
                    <th>Bill Type</th>
                    <th>Account ID</th>
                    <th>Location Owner</th>
                    <th>Due Date</th>
                    <th>Remarks</th>
                    <th>April</th>
                    <th>May</th>
                    <th>June</th>
                    <th>July</th>
                    <th>August</th>
                    <th>September</th>
                    <th>October</th>
                    <th>November</th>
                    <th>December</th>
                    <th>January</th>
                    <th>February</th>
                    <th>March</th>
                  </tr>
                </thead>
                <tbody>
                  {billParametersData.map((item, index) => {
                    let rowspan = 1;
                    if (index > 0 && item?.Branch?.name === billParametersData[index - 1]?.Branch?.name) {
                      rowspan = 0;
                    } else {
                      for (let i = index + 1; i < billParametersData.length; i++) {
                        if (item?.Branch?.name === billParametersData[i]?.Branch?.name) {
                          rowspan++;
                        } else {
                          break;
                        }
                      }
                    }
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        {rowspan > 0 && (
                          <td rowSpan={rowspan} style={{ verticalAlign: 'middle' }}>
                            {item?.Branch?.Company?.name}
                          </td>
                        )}
                        {rowspan > 0 && (
                          <td rowSpan={rowspan} style={{ textTransform: 'capitalize', verticalAlign: 'middle' }}>
                            {item?.Branch?.type}
                          </td>
                        )}
                        {rowspan > 0 && (
                          <td rowSpan={rowspan} style={{ verticalAlign: 'middle' }}>
                            {item?.Branch?.name}
                          </td>
                        )}
                        <td>{item?.locationRefName}</td>
                        <td>{item?.billType}</td>
                        <td>{item?.accountId}</td>
                        <td>{item?.locationOwnerName}</td>
                        <td>{`${item?.dueDate} th`}</td>
                        <td>{item?.remarks}</td>
                        {generateAmountColumns(item?.BillDetails, state.financialYear)}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BillConsolidatedReport;
